import { Component, Input, OnInit } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
  selector: 'spv2-grid-return-type-filter',
  templateUrl: './grid-return-type-filter.component.html',
  styleUrls: ['./grid-return-type-filter.component.scss']
})
export class GridReturnTypeFilterComponent extends GridFilterBase<string> {
  @Input() searchString : string;
  @Input() smallView = false;
}


